const anchor = document.querySelectorAll('.navigation__items > li > a[href*="/#"]');

for(let i = 0, l = anchor.length; i < l; i++) {
	const item = anchor[i];

	item.addEventListener('click', element => {

		const targetHref = element.currentTarget.getAttribute('href');
		const link = document.createElement('a');
		link.href = targetHref;

		/**
		 * Only scroll if the target page and the current page is the same.
		 * Clicking on an anchor on a different page use the default behavior
		 * and opens the link and jump to the anchor.
		 */
		if(link.pathname === location.pathname) {
			element.preventDefault();
		}

		const targetAnchor = targetHref.match('\/(#.*)')[1]; // The group is on index 1
		const targetElement = document.querySelector(targetAnchor);
		targetElement.scrollIntoView({ block: "start", behavior: 'smooth' });
	});
}
